import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/_service/user.service';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { Router } from '@angular/router';
import { Validators, FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class CreateUserComponent implements OnInit {

  hide = true;
  model: any = {};
  userCreated: any = [];
  userNotCreated: any = [];
  duplicateUserNameOrEmail: any = [];
  invalidDomainName: any = {};
  createInternalUserForm: FormGroup;
  isModified = false;

  constructor(
    private userService: UserService,
    private alertify: AlertifyService,
    private router: Router,
    public fb: FormBuilder,
    public dialog: MatDialog
  ) {
    this.createInternalUserForm = fb.group({
      emailFormControl: new FormControl('', [
        Validators.required,
        // Validators.email,
        Validators.pattern('^[a-zA-Z0-9_.+-]+[@]{1}[a-zA-Z0-9-.]+[.]{1}[a-zA-Z0-9]{2,3}$'),
      ]),
      firstNameFormControl: new FormControl('', [
        Validators.required,
        Validators.maxLength(50),
        this.WhitespaceValidator
      ]),
      lastNameFormControl: new FormControl('', [
        Validators.required,
        Validators.maxLength(70),
        this.WhitespaceValidator
      ]),
      passwordFormControl: new FormControl('', [
        Validators.required,
        this.WhitespaceValidator,
        Validators.minLength(6),
        Validators.maxLength(20),
        // required: combination of letters and numbers
        // optional: characters, capital letters
        Validators.pattern('^(?=[^a-z]*[a-z])(?=.*[0-9])(?=[^A-Z]*[A-Za-z]).{6,20}$')
      ]),
      // contactNameFormControl : new FormControl('', []).clearValidators(),
      postalCodeFormControl: new FormControl('', []).clearValidators(),
      addressLine1FormControl: new FormControl('', []).clearValidators(),
      addressLine2FormControl: new FormControl('', []).clearValidators(),
      countryFormControl: new FormControl('', []).clearValidators(),
      cityFormControl: new FormControl('', []).clearValidators(),
      provinceFormControl: new FormControl('', []).clearValidators(),
      faxNumberFormControl: new FormControl('', []).clearValidators(),
      phoneNumberFormControl: new FormControl('', []).clearValidators(),
    });
  }

  ngOnInit() {}

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  createInternalUser() {
    return this.userService.createInternalUser(this.model).subscribe(
      res => {
        this.invalidDomainName = res.headers.get('emailNotApproved');
        if (this.invalidDomainName) {
          this.alertify.error(this.invalidDomainName);
        }
        this.duplicateUserNameOrEmail = res.headers.get('duplicateuser');
        if (this.duplicateUserNameOrEmail) {
          this.alertify.warning(this.duplicateUserNameOrEmail);
        }
        this.userCreated = res.headers.get('internalusercreated');
        if (this.userCreated) {
          this.isModified = true;
          this.alertify.success(this.userCreated);
          this.dialog.closeAll();
        }
      }, error => {
        this.alertify.error('Something went wrong');
      }
    );

  }

}
